import firebase from 'firebase'
import '@firebase/firestore'

const config = {
  apiKey: "AIzaSyBuqHKjkF_4TQQVSjSh8XfOpKHaQZnQCxo",
  authDomain: "react-ttt.firebaseapp.com",
  databaseURL: "https://react-ttt.firebaseio.com",
  projectId: "react-ttt",
  storageBucket: "react-ttt.appspot.com",
  messagingSenderId: "613262241181",
  appId: "1:613262241181:web:afd70af1c46a0d73"
}
const app = firebase.initializeApp(config)
export const firestore = app.firestore()

// 匿名認証
firebase.auth().signInAnonymously();
let isFirst = true
firebase.auth().onAuthStateChanged((user) => {
  if (isFirst) {
    isFirst = false
    return
  }
  if (!user) {
    window.location.reload()
  }
});
